export enum ListingType {
  jobs = 'jobs',
  profiles = 'profiles',
}
